import { store, itiHttpService, itiMessageService, itiSignalRService, ItiString} from '@/iti-core-vue';
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { API } from '@/shared/api';
import { Notification } from '@/shared/dtos/notificacion';

@Module({
  namespaced: true,
  name: 'NotificationCounterModule',
  store,
  dynamic: true,
})
class NotificationCounterModule extends VuexModule {

public counter: number = 0;

@Mutation
public setCounter(num: number){
    this.counter = num;
}

@Action
public async fetchNotificationNumber(){
  const url = ItiString.Format('{0}', API.notifications);
  itiHttpService.get(API.notifications+'/num',null, false).then((response) =>{
    this.context.commit('setCounter', response);
    });
}

@Action
public decrementCounter(){
    this.context.commit('setCounter', this.counter - 1)
}

@Action
public incrementCounter(){
    this.context.commit('setCounter', this.counter + 1)
}

}
export default getModule(NotificationCounterModule);
